import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { UsersLikeHttpResult } from '../models/like.model';

@Injectable({
  providedIn: 'root',
})
export class LikeApi {
  constructor(private readonly http: HttpClient) { }

  getUserLikedActivity(activityId: number, sessionId: number, page: number): Observable<UsersLikeHttpResult> {
    const params = new HttpParams()
      .set('page', page);
    const url = environment.api.dashboard.likeActivity.replace('{activity}', '' + activityId).replace('{session}', '' + sessionId);
    return this.http.get<UsersLikeHttpResult>(url, { params });
  }

  postLikeActivity(activityId: number, sessionId: number): Observable<any> {
    const url = environment.api.dashboard.likeActivity.replace('{activity}', '' + activityId).replace('{session}', '' + sessionId);
    return this.http.post(url, null);
  }

  deleteLikeActivity(activityId: number, sessionId: number): Observable<any> {
    const url = environment.api.dashboard.likeActivity.replace('{activity}', '' + activityId).replace('{session}', '' + sessionId);
    return this.http.delete(url);
  }

  getUserLikedPlaylist(playlistId: number, page: number): Observable<UsersLikeHttpResult> {
    const params = new HttpParams()
      .set('page', page);
    const url = environment.api.dashboard.likePlaylist.replace('{playlist}', '' + playlistId);
    return this.http.get<UsersLikeHttpResult>(url, { params });
  }

  postLikePlaylist(playlistId: number): Observable<any> {
    const url = environment.api.dashboard.likePlaylist.replace('{playlist}', '' + playlistId);
    return this.http.post(url, null);
  }

  deleteLikePlaylist(playlistId: number): Observable<any> {
    const url = environment.api.dashboard.likePlaylist.replace('{playlist}', '' + playlistId);
    return this.http.delete(url);
  }

  getUserLikedVideo(videoId: number, page: number): Observable<UsersLikeHttpResult> {
    const params = new HttpParams()
      .set('page', page);
    const url = environment.api.dashboard.likeVideo.replace('{video}', '' + videoId);
    return this.http.get<UsersLikeHttpResult>(url, { params });
  }

  postLikeVideo(videoId: number): Observable<any> {
    const url = environment.api.dashboard.likeVideo.replace('{video}', '' + videoId);
    return this.http.post(url, null);
  }

  deleteLikeVideo(videoId: number): Observable<any> {
    const url = environment.api.dashboard.likeVideo.replace('{video}', '' + videoId);
    return this.http.delete(url);
  }
}
